module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "cwxx"
    }
  }, _vm._l((_vm.list), function(item) {
    return _c('div', [_c('p', [_c('b', [_vm._v(_vm._s(item.ND) + "年度")])]), _vm._v(" "), _c('p', [_vm._v("净资本：" + _vm._s(item.JZB))]), _vm._v(" "), _c('p', [_vm._v("净资产：" + _vm._s(item.JZC))]), _vm._v(" "), _c('p', [_vm._v("权益总额：" + _vm._s(item.QYZE))]), _vm._v(" "), _c('p', [_vm._v("手续费收入：" + _vm._s(item.SXFSR))]), _vm._v(" "), _c('p', [_vm._v("净利润：" + _vm._s(item.JLR))]), _vm._v(" "), _c('p', [_vm._v("主审会计事务所：" + _vm._s(item.SWS))]), _vm._v(" "), _c('p', [_vm._v("审计意见类型：" + _vm._s(item.SJYJ))]), _vm._v(" "), (_vm.list.length > 1) ? _c('div', {
      staticClass: "line"
    }) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "margin-b"
    })])
  }), 0)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1be1aa96"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/xxgs/nr/cwxx.vue
// module id = 808
// module chunks = 2